import { ApiFetch } from '../../../shared/utils/fetch';
import type {
  RankedSearchResponse,
  SearchAnalyticsQuery,
  SearchStats,
  TopSearchesQuery,
} from '../types';

function buildQuery(query: object): string {
  const search = new URLSearchParams();
  Object.entries(query as Record<string, string | number | undefined>).forEach(([key, value]) => {
    if (value !== undefined && value !== '') search.append(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

/**
 * osprey-api `/search-analytics/*` (PE-1288). TCS-staff only (CollectiveOnlyGuard)
 * + `SEARCH.READ`, enforced server-side. Merchant-scoped — every route 400s
 * without an `x-tenant-id` header (ApiFetch only sends one once a merchant is
 * selected), so callers must gate on that themselves before firing these.
 */
export const searchAnalyticsApi = {
  getTopSearches: async (query: TopSearchesQuery = {}): Promise<RankedSearchResponse> =>
    ApiFetch.get<RankedSearchResponse>(
      `/search-analytics/top-searches${buildQuery(query)}`,
    ),

  getNoResultSearches: async (query: TopSearchesQuery = {}): Promise<RankedSearchResponse> =>
    ApiFetch.get<RankedSearchResponse>(
      `/search-analytics/no-result-searches${buildQuery(query)}`,
    ),

  getStats: async (query: SearchAnalyticsQuery = {}): Promise<SearchStats> =>
    ApiFetch.get<SearchStats>(`/search-analytics/stats${buildQuery(query)}`),
};
